import dayjs from "dayjs";
import { MessageSquare, ChevronDown, ChevronUp } from "lucide-react";

const STATUS = {
  open: "bg-amber-50 text-amber-700 border-amber-200",
  in_review: "bg-blue-50 text-blue-700 border-blue-200",
  resolved: "bg-[#f0f9f0] text-[#009900] border-[#009900]/30",
};

export const ComplaintCard = ({ c, isAdmin, isOpen, onToggle, reply, setReply, busy, onRespond }) => (
  <div className="bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden" data-testid={`complaint-card-${c.complaint_id}`}>
    <button className="w-full text-left p-4 flex flex-wrap items-center gap-3" onClick={onToggle} data-testid="complaint-expand-btn">
      <span className="font-mono font-bold text-[#144733]">{c.complaint_id}</span>
      <span className={`text-[10px] uppercase tracking-wide font-semibold border rounded-full px-2.5 py-1 ${STATUS[c.status]}`} data-testid="complaint-status-badge">
        {c.status.replace("_", " ")}
      </span>
      <span className="text-sm font-semibold text-[#0F1E17]">{c.subject}</span>
      <span className="text-xs text-[#57685e]">{c.category} · {c.booking_ref}</span>
      {isAdmin && <span className="text-xs text-[#8a978f]">{c.user_email}</span>}
      <span className="ml-auto text-xs text-[#8a978f] flex items-center gap-2">
        {dayjs(c.created_at).format("DD MMM YYYY")}
        {isOpen ? <ChevronUp className="w-4 h-4 text-[#009900]" /> : <ChevronDown className="w-4 h-4 text-[#009900]" />}
      </span>
    </button>
    {isOpen && (
      <div className="border-t border-[#E2E8F0] p-4 bg-[#F8FAFC] space-y-3">
        <p className="text-sm text-[#334139]">{c.description}</p>
        {c.responses.map((r) => (
          <div key={r.at} className="bg-white border border-[#E2E8F0] rounded-lg p-3 text-sm" data-testid="complaint-response">
            <div className="flex items-center gap-2 text-xs text-[#009900] font-semibold mb-1">
              <MessageSquare className="w-3.5 h-3.5" /> {r.by} · {dayjs(r.at).format("DD MMM, HH:mm")}
            </div>
            <p className="text-[#334139]">{r.message}</p>
          </div>
        ))}
        {isAdmin && c.status !== "resolved" && (
          <div className="flex flex-col sm:flex-row gap-2">
            <input className="field-input flex-1" placeholder="Write a response…" value={reply.message}
              onChange={(e) => setReply({ ...reply, message: e.target.value })} data-testid="complaint-reply-input" />
            <select className="field-input sm:w-40" value={reply.status} onChange={(e) => setReply({ ...reply, status: e.target.value })} data-testid="complaint-status-select">
              <option value="in_review">In review</option>
              <option value="resolved">Resolved</option>
              <option value="open">Open</option>
            </select>
            <button onClick={() => onRespond(c.complaint_id)} disabled={busy || !reply.message.trim()}
              className="btn-cta rounded px-4 py-2.5 text-xs" data-testid="complaint-respond-btn">Send</button>
          </div>
        )}
      </div>
    )}
  </div>
);
